import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Link, useNavigate } from "react-router-dom";

import { CryptoState } from "../ContextApi";
import Home from "./Home";
import Blog from "./Blog";

import DrawerMenu from "./DrawerMenu";

const typo = {
  flexGrow: 1,
  fontFamily: "Montserrat",
  fontWeight: "bold",
  cursor: "pointer",
  minWidth: 99,
};
const menu = {
  fontFamily: "Montserrat",
  fontWeight: "bold",
  color: "rgb(23,24,27)",
};
const button = {
  fontWeight: 600,

  textTransform: "none",
  color: "rgb(23,24,27)",
};
const button1 = {
  fontWeight: 600,

  textTransform: "none",
  // color:'rgb(23,24,27)'
};
export default function Header() {
  let Navigate = useNavigate();

  const [selectedTab, setSelectedTab] = useState(0);
  const tabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const { currency, setCurrency } = CryptoState();
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  console.log(isMatch);

  return (
    <>
      <AppBar color="transparent" position="static">
        <Toolbar>
          <Typography onClick={() => Navigate("/")} style={typo}>
            Crypto App
          </Typography>
          {isMatch ? (
            <>
              {" "}
              <DrawerMenu />
            </>
          ) : (
            <>
              {" "}
              <Tabs
                value={selectedTab}
                onChange={tabChange}
                style={{ flexGrow: 1 }}
              >
                <Tab onClick={() => Navigate("/")} style={menu} label="Home" />
                <Tab
                  onClick={() => Navigate("/blog")}
                  style={menu}
                  label="blog"
                />
              </Tabs>
              <div style={{ display: "flex" }}>
                <Button style={button} variant="text">
                  Log In
                </Button>
                <Button style={button1} variant="contained">
                  Sign Up
                </Button>
              </div>
            </>
          )}
        </Toolbar>
      </AppBar>
      {/* {selectedTab===0&& <Home/>}
  {selectedTab===1&& <Blog/>} */}
    </>
  );
}
